import UAParser from 'ua-parser-js'

export function boxEventProperties() {
  const userAgent = window.navigator.userAgent
  const ua = new UAParser(userAgent)
  const uaResults = ua.getResult()
  const device = uaResults?.device || {}

  return {
    device:
      device.type &&
      ['console', 'mobile', 'tablet', 'smarttv', 'wearable', 'embedded'].includes(device.type)
        ? device.type
        : 'desktop',
    deviceName: device?.model,
    browser: uaResults?.browser?.name,
    browserVersion: uaResults?.browser?.version,
    os: uaResults?.os?.name,
  }
}
